export const PUBLIC_ROUTE_ALIASES = Object.freeze({
  "/mixing": "/mix-portal",
  "/custom-beats": "/custom-portal",
  "/recording": "/beats?start=recording",
});

export function getPublicAliasDestination(pathname) {
  const normalized = `/${String(pathname || "").split(/[?#]/, 1)[0].replace(/^\/+|\/+$/g, "")}`;
  return PUBLIC_ROUTE_ALIASES[normalized] || null;
}

export function isPublicAliasPath(pathname) {
  return Boolean(getPublicAliasDestination(pathname));
}
